import AppLayoutAdmin from "@/layouts/AppLayoutAdmin.vue";
import Whatsapp from "@/pages/dossier/canaux/Whatsapp.vue";
import ShowWhatsapp from "@/pages/dossier/canaux/ShowWhatsapp.vue";


export default{
    path: "/canaux",
    component: AppLayoutAdmin,
    meta: { requiredAuth: true },
    children: [
        {
            path: "whatsapp",
            name: "CanauxWhatsapp",
            component: Whatsapp
        },
        {
            path: "whatsapp/:id/show",
            name: "CanauxShowWhatsapp",
            component: ShowWhatsapp
        },
    ]
}